module.exports = __webpack_public_path__ + "img/arrow-down-03.d839a476.svg";